<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(HeaderGlobalHeading="Notification" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Your Notification
                        .header-cta
                            button.btn-default(@click="updateReadNotification(null, true)") Mark all as read
            .box__body
                //- form.block
                .block
                    .box-notif-type
                        .flex.no-wrap.pb-4
                            .wrapper-radio
                                input(type="radio" value="all" v-model="notification_type")
                                .ui-radio.flex.items-center
                                    .radio.flex.items-center.justify-center
                                    strong(v-if="notification_count_all > 0")
                                        span All
                                        .block
                                            span.ml-1.text-xs.text-red-900.bg-red-300.font-bold.inline-block.px-1.rounded-full {{ notification_count_all }}
                                    strong(v-else)
                                        span All
                            .wrapper-radio.ml-6
                                input(type="radio" value="territory_virtual" v-model="notification_type")
                                .ui-radio.flex.items-center
                                    .radio.flex.items-center.justify-center
                                    strong(v-if="notification_count_territory_virtual > 0")
                                        span Territory Virtual
                                        .block
                                            span.ml-1.text-xs.text-red-900.bg-red-300.font-bold.inline-block.px-1.rounded-full {{ notification_count_territory_virtual }}
                                    strong(v-else)
                                        span Territory Virtual
                    
                            .wrapper-radio.ml-6
                                input(type="radio" value="meeting_point" v-model="notification_type")
                                .ui-radio.flex.items-center
                                    .radio.flex.items-center.justify-center
                                    strong(v-if="notification_count_meeting_point > 0")
                                        span Meeting Point
                                        .block
                                            span.ml-1.text-xs.text-red-900.bg-red-300.font-bold.inline-block.px-1.rounded-full {{ notification_count_meeting_point }}
                                    strong(v-else)
                                        span Meeting Point
                        
                        //- .wrapper-radio.ml-6
                            input(type="radio" value="general" v-model="notification_type")
                            .ui-radio.flex.items-center
                                .radio.flex.items-center.justify-center
                                strong
                                    span General
                                    span.ml-1.text-xs.text-red-900.bg-red-300.font-bold.inline-block.px-1.rounded-full 9
                    .block
                        .block(v-if="load_data_status_notification_list === 'loading'")
                            .flex.flex-wrap.items-center.justify-center
                                Spinner(show="true" size="48")


                        template(v-else-if="notification_list.data && notification_list.data.length > 0")
                            router-link.block(v-for="(data,index) in notification_list.data" :key="data.id" :to="data.type === 'territory_virtual' ? '/territory-virtual/'+ data.data.territory_virtual.id +'/detail/notification/'+ data.data.target.id +'/'+ encrypt(data.data.target.msisdn) : (data.type === 'meeting_point' ? '/multi-tracking/'+data.data.multi_tracking.id+'/meeting-point/'+ data.data.meeting_point_id : '#')" @click.native="data.status.toLowerCase() === 'unread' ? updateReadNotification(data.id) : ''")
                                .list-notif.flex.items-center.justify-between.border-b.p-4.rounded
                                    //- .content.flex-grow.mr-1.font-bold.text-gray-700(v-if="data.status.toLowerCase() === 'unread'") 
                                    //- .content.flex-grow.mr-1.font-normal.text-gray-500(v-else)

                                    .content.flex-grow.mr-1(:class="data.status.toLowerCase() === 'unread' ? 'font-bold text-gray-200' : 'font-normal text-gray-600'")
                                        //- | Notification {{ data.type === 'territory_virtual' ? 'Territory Virtual: There is a target named '+ data.data.target.name +' into the territory '+ data.data.territory_virtual.name : 'Meeting Point: There was a meeting of '+ data.data.multi_tracking.group_name }}.
                                        | Notification {{ data.type === 'territory_virtual' ? 'Territory Virtual: There is a target named '+ data.data.target.name +' into the territory '+ data.data.territory_virtual.name : (data.type === 'meeting_point' ? 'Meeting Point: There was a meeting of '+ data.data.multi_tracking.group_name : titleCase(data.type)) }}.
                                        .status.text-xs.pt-1 {{ titleCase(data.type) }} • {{ data.created_at.substring(0, 24) }}
                                        //- .status.text-xs.pt-1 {{ data.type === 'territory_virtual' ? 'Territory Virtual' : 'Meeting Point' }} • {{ data.created_at.substring(0, 24) }}

                                    template(v-if="data.status.toLowerCase() === 'unread'")
                                        .block
                                            .bubble.w-3.h-3.rounded-full.bg-red-400
                                    template(v-else)

                        //- router-link(to="/notif").block
                            .list-notif.flex.items-center.justify-between.border-b.py-4(class="hover:bg-gray-100")
                                .bubble.w-3.h-3.rounded-full.bg-red-500.mr-4
                                .content.flex-grow.mr-1.font-bold.text-gray-700 Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                .status.text-xs.text-gray-500 Meeting Point • 2 hours ago

                        .block.text-center(v-else) No Data Available

                        .block
                            .mt-5
                            vue-ads-pagination(
                                :total-items="total_data"
                                :items-per-page="items_per_page"
                                :page="page"
                                :max-visible-pages="5"
                            )
                                template(slot="buttons" slot-scope="props")
                                    vue-ads-page-button(
                                        v-for="(button, key) in props.buttons"
                                        :key="key"
                                        v-bind="button"
                                        :class="{'bg-yellow-dark': button.active}"
                                        @page-change="page = button.page"
                                        @range-change="start = button.start; end = button.end"
                                    )

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue'
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import { encrypt } from '@/util/crypto';

export default {
    name: 'PageNotification',
    components: {
        HeaderGlobal,
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Notification',
                    url: '/notification',
                },
            ],

            notification_type: 'all',
            notification_count_all: 0,
            notification_count_territory_virtual: 0,
            notification_count_meeting_point: 0,

            // pagination
            total_data: 0,
            items_per_page: 10,
            // size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_notification_list',
            'notification_list',
            'notification_count',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageNotification') {
                this.getData();
            }

            if (newData === 'PageNotification') {
                if (oldData !== 'PageNotification') {
                    this.items_per_page = 10;
                    this.page = 0;
                    // this.keyword = '';
                    this.$store.commit('setNotificationList', {});
                }

                this.getData();
            }
        },
        notification_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            } else {
                this.total_data = 0;
            }
        },
        notification_count(newData) {
            this.setNotificationCount(newData);
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        notification_type() {
            this.items_per_page = 10;
            this.page = 0;
            this.$store.commit('setNotificationList', {});

            this.getData();
        },
        notification_count_all() {},
        notification_count_territory_virtual() {},
        notification_count_meeting_point() {},
    },
    methods: {
        titleCase(str) {
            return str.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())
        },
        encrypt(string) {
            return encrypt(string);
        },
        getData() {
            // console.log(this.route_name);
            if (this.route_name === 'PageNotification') {
                // for dispatch get data

                this.$store.dispatch('getNotificationCount');

                this.$store.dispatch('getNotificationList', [this.items_per_page, (this.page + 1), (this.notification_type === 'all' ? null : this.notification_type)]);

                // if (this.notification_list.total_page && this.notification_list.total_page > 1) {
                    // console.log(this.notification_list.total_page)
                    this.pagination();
                // }
            }
        },
        setNotificationCount(data=[]) {
            if (data.length === 0)
                data = this.notification_count;

            if (data.length > 0) {
                let find_territory_virtual = false;
                let find_meeting_point = false;
                for (var i = 0; i < data.length; i++) {
                    this['notification_count_'+data[i].type] = data[i].count;

                    if (data[i].type === 'territory_virtual') 
                        find_territory_virtual = true;

                    if (data[i].type === 'meeting_point') 
                        find_meeting_point = true;
                }

                if (find_territory_virtual === false)
                    this.notification_count_territory_virtual = 0;

                if (find_meeting_point === false)
                    this.notification_count_meeting_point = 0;

            } else {
                this.notification_count_all = 0;
                this.notification_count_territory_virtual = 0;
                this.notification_count_meeting_point = 0;
            }
        },
        async updateReadNotification(id=null, unread_all=false) {
            // console.log('update notif')

            if (id !== null) {
                await this.$store.dispatch('getUpdateNotification', id)
                .then(() => {
                    this.$store.dispatch('getNotificationCount');
                    // this.getData();
                });
                await this.getData();
            }

            if (unread_all === true) {
                await this.$swal.fire({
                    icon: 'warning',
                    title: 'Are you sure want to mark '+ this.notification_type.replace('_', ' ') +' as read?',
                    // text: 'Role : ' + name,
                    confirmButtonText: 'Yes!',
                    confirmButtonColor: '#DD6B55',
                    showCancelButton: true,
                    allowOutsideClick: false,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.showLoading(true);
                        this.$store.dispatch('getUpdateAllNotification', (this.notification_type === 'all' ? null : this.notification_type))
                        .then(() => {
                            // this.$store.dispatch('getNotificationCount');
                            this.showLoading(false);
                            this.getData();
                        });
                    }
                });
                // await this.getData();
            }
            // await this.$store.dispatch('getNotificationCount');
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
    },
    mounted() {
        // this.$store.dispatch('getNotificationCount');
        this.getData();
        EventEmit.$on('notificationOnPageNotification', () => {
            this.items_per_page = 10;
            this.page = 0;
            this.notification_type = 'all';
            this.$store.commit('setNotificationList', {});
            this.getData();
        });
    }
}
</script>

<style lang="sass">
.box-notif-type
    padding: 16px
    max-width: 100%
    overflow: auto
    .wrapper-radio
        display: flex
    .ui-radio
        strong
            display: flex
            align-items: center
        span
            white-space: nowrap
</style>


